<template>
  <div>
    <LoggedInSidebar />
    <div @click="closeSidebar" class="view">
      <LoggedInHeader />
      <router-view />
    </div>
  </div>
</template>

<script>
import LoggedInHeader from '@/components/LoggedInHeader'
import LoggedInSidebar from '@/components/LoggedInSidebar'

export default {
  name: 'LoggedIn',
  components: {
    LoggedInHeader,
    LoggedInSidebar
  },
  methods: {
    closeSidebar () {
      const sidebar = document.getElementById('sidebar')

      if (sidebar.classList.contains('active')) {
        setTimeout(() => {
          sidebar.classList.remove('active')
        }, 500)
        sidebar.classList.add('inactive')
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants.scss';

.view {
  float: right;
  width: 85%;
  min-height: 100vh;
  background-color: $light-grey;
}

@media screen and (max-width: 960px) {
  .view {
    width: 100%;
  }
}
</style>
